import * as React from 'react'

import { Box, Section, Spinner, Table } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { useCustomTimeRange } from 'modules/attendance/hooks/useCustomTimeRange'
import { useFetchCustomTimeRanges } from 'modules/attendance/hooks/useFetchCustomTimeRanges'
import { translateDayInPlural } from 'modules/attendance/lib/translateDays'

import NewTableBody from './CompensationTabBody'
import NewHeaderCell from './CompensationTabBody/HeaderCell'
import InfoSection from './InfoSection'
import AddNewBlockWizard from './Modals/AddNewBlockWizard'
import * as styles from './index.vanilla.css'

interface Props {
  settingId: number
}

const CustomTimeRanges = ({ settingId }: Props) => {
  const { dayEnums } = useCustomTimeRange()
  const { ranges: customTimeRanges, loading } = useFetchCustomTimeRanges(settingId)
  const [isAddingNewBlock, setIsAddingNewBlock] = React.useState(false)

  if (loading)
    return (
      <Box justifyContent="center" alignItems="center" height="full">
        <Spinner />
      </Box>
    )

  const tableHeaders = [' ', ...dayEnums.map((day) => translateDayInPlural(day))]
  const hasTimeBlocks = customTimeRanges.customTimeRanges.length > 0

  return (
    <Section.FullWidth
      description={i18n.t('time_tracking.settings.time_blocks.subtitle')}
      illustration="night"
      title={i18n.t('time_tracking.settings.time_blocks.title')}
      action={{
        onClick: () => setIsAddingNewBlock(true),
        label: i18n.t('time_tracking.settings.time_blocks.actions.new'),
      }}
    >
      <Box gap="s24">
        <Box gap="s24" className={styles.gradient}>
          <Table density="compact" overflowX="auto" autoWidth>
            <Table.Head>
              <Table.Row>
                {tableHeaders.map((title) => (
                  <NewHeaderCell key={title} text={title} />
                ))}
              </Table.Row>
            </Table.Head>
            <NewTableBody timeRanges={customTimeRanges} settingId={settingId} />
          </Table>
        </Box>
        <InfoSection hasTimeBlocks={hasTimeBlocks} />
      </Box>
      {isAddingNewBlock && (
        <AddNewBlockWizard settingId={settingId} onClose={() => setIsAddingNewBlock(false)} />
      )}
    </Section.FullWidth>
  )
}

export default CustomTimeRanges
